import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail, Calendar } from 'lucide-react';
import { openChat } from '../utils/chat';

export const CTA = ({ onOpenForm }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#0A1F44] via-[#153356] to-[#0A1F44] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          {/* Heading */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Ready to Protect Your Brand?
          </h2>
          
          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
            Schedule a free consultation with our IP attorneys and take the first step toward securing your intellectual property.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
            <Button 
              onClick={onOpenForm}
              className="liquid bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1F44] font-bold px-8 py-6 text-lg"
            >
              Start Trademark Registration
            </Button>
            <Button
              onClick={openChat}
              variant="outline"
              className="liquid-white border-2 border-white text-white hover:bg-white hover:text-[#0A1F44] font-bold px-8 py-6 text-lg"
            >
              Discuss with Attorney
            </Button>
          </div>

          {/* Contact Info */}
          <div className="pt-8 flex flex-col md:flex-row justify-center items-center gap-6 text-gray-300">
            <div className="flex items-center space-x-2">
              <Phone className="w-5 h-5 text-[#D4AF37]" />
              <span className="font-medium">+1 (646) 687-2501</span>
            </div>
            <div className="hidden md:block w-px h-6 bg-gray-500"></div>
            <div className="flex items-center space-x-2">
              <Mail className="w-5 h-5 text-[#D4AF37]" />
              <span className="font-medium">info@otistrademark.com</span>
            </div>
          </div>

          {/* Trust Message */}
          <div className="pt-6">
            <p className="text-gray-400 text-sm">No obligation. Free initial consultation. Transparent pricing.</p>
          </div>
        </div>
      </div>
    </section>
  );
};